import { render, staticRenderFns } from "./BaseSearchBox.vue?vue&type=template&id=45a1c7e2&"
import script from "./BaseSearchBox.vue?vue&type=script&lang=js&"
export * from "./BaseSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchBox.vue?vue&type=style&index=0&id=45a1c7e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports